<template>
  <section>
    <div class="content">
      <div class="warp">
        <div class="container">
          <div v-if="SubpageList[type]&&SubpageList[type].html&&index==2" v-html="SubpageList[type].html"></div>
          <div class="imgBox" v-if="index==1">
            <div class="imgList" v-if="SubpageList[0].dataType == 1" v-for="(item,i) in SubpageList[0].imgList" :key="i">
              <img v-if="item.type == 1" :src="item.key | imageUrl" alt="">
              <div v-if="item.type == 2" :style="{ background: item.color }">
                <video controls :src="item.key"></video>
              </div>
              <div v-if="item.type == 3" :style="{ background: item.color }">
                <div v-html="item.key" style="text-align: center;"></div>
              </div>
            </div>
            <div class="htmlBox" v-if="SubpageList[0].dataType == 2" v-html="SubpageList[0].content"></div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  metaInfo() {
    return {
      title: this.$t("global.竞赛首页") + " | MANA",
    };
  },
  data() {
    return {
      SubpageList: [],
      type: 0,
      index: null
    };
  },
  created() {
    this.type = this.$route.query.type;
    this.init();
  },
  computed: {
    language() {
      return this.$language();
    },
  },
  watch: {
      $route() {
          this.type = this.$route.query.type;
          this.init()
      }
  },
  methods: {
    init() {
      this.getDetail();
    },
    getDetail() {
      this.contestName = this.$route.params.contestName;
      if (this.contestName) {
        this.$http
          .get("/api/nmatch/url/" + this.contestName)
          .then((response) => {
            if (response.code === "OK") {
              var list = response.data.zhPcCustomCode &&
                    JSON.parse(response.data.zhPcCustomCode);      
              if (list[0].type) {
                var data1 = list[this.$route.query.type].homeList.filter((item,i)=>{
                  return item.type == 1
                })
                var data2 = list[this.$route.query.type].homeList.filter((item,i)=>{
                  return item.type == 3
                })
                this.SubpageList = this.language === "zh" ? data1 : data2[0].dataType ? data2 : data1;
                this.index = 1;
              } else {
                this.SubpageList =
                this.language === "zh"
                  ? response.data.zhPcCustomCode &&
                    JSON.parse(response.data.zhPcCustomCode)
                  : (response.data.enPcCustomCode &&
                      JSON.parse(response.data.enPcCustomCode)) ||
                    (response.data.zhPcCustomCode &&
                      JSON.parse(response.data.zhPcCustomCode));
                this.index = 2;      
              }
              
            }
          });
      }
    },
  },
};
</script>
<style>
.contestHome .content .warp .container .imgBox .imgList iframe{
  display: block;
  width: 60%;
  position: relative;
  left: 50%;
  height: 500px;
  transform: translateX(-50%);
}
</style>
<style scoped>
.contestHome {
  min-height: calc(100vh - 665px);
}
>>>.htmlBox img {
    margin: 0px auto;
    text-align: center;
    display: block;
    max-width: 1440px;
    height: auto;
}
.content .nav {
  display: flex;
  flex-direction: row;
  padding: 40px 0;
}
.nav li {
  height: 25px;
  margin-right: 40px;
}
.nav li a {
  line-height: 25px;
  font-size: 18px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: #999;
}
.nav li a.selected {
  color: #333;
  font-weight: 600;
}
.warp {
  margin: 0 auto;
  display: flex;
  flex-direction: row;
}
.warp .container {
  flex: 1;
  margin: 0;
  width: 1110px;
}
.warp .right {
  width: 250px;
  margin-top: -60px;
  padding-left: 10px;
}
.rightIntro ul {
  display: flex;
  flex-direction: column;
}
.rightIntro ul li {
  padding-right: 2px;
  margin-bottom: 20px;
  border-bottom: none;
}
.rightIntro ul li a {
  display: flex;
  flex-direction: row;
  width: 100%;
}
.geek_text {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-left: 10px;
}
.geekText {
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  color: #333;
  font-size: 14px;
}
.geekTime {
  text-align: left;
  margin-bottom: 0;
  color: #999;
}
.container {
  font-size: 14px;
}
.container .imgBox .imgList img{
  max-width: 100%;
  text-align: center;
  display: block;
}
.container .imgBox .imgList video{
  width: 38%;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  display: block;
}
.container .imgBox .htmlBox{
  margin: 0 auto;
  max-width: 1440px;
  width: max-content;
  padding-top: 50px;
}
</style>





// WEBPACK FOOTER //
// src/pages/match/contestPage.vue